import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AgentDashboardKPIs from '../components/AgentDashboardKPIs';

/**
 * Dashboard Principal - Inteligencia de Negocio
 * 
 * Muestra KPIs críticos optimizados con MongoDB Aggregation
 */
export const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Redirigir Super Admin a su página de gestión
  useEffect(() => {
    if (user?.role === 'super_admin') {
      navigate('/principal-users');
      return;
    }
  }, [user, navigate]);

  // Si es Super Admin, no mostrar nada (ya redirigido)
  if (user?.role === 'super_admin') {
    return null;
  }

  // Dashboard de KPIs optimizado
  return <AgentDashboardKPIs />;
};
